import Input from "../../components/Input/Input";
import Checkbox from "../../components/Checkbox/Checkbox";

const UserForm = ({formik, isOwnProfile}) => {
    //TODO delete this
    if(formik == null) return ;

    return (
        <form id="userForm" onSubmit={formik.handleSubmit}>
            <Input
                name="name"
                label="Name"
                formik={formik}
            />
            <Input
                name="surname"
                label="Surname"
                required={false}
                formik={formik}
            />
            <Input
                name="email"
                label="Email"
                type="email"
                formik={formik}
            />
            <Input
                name="image"
                label="Profile Picture"
                type="picture"
                required={false}
                formik={formik}
            />

            {formik.values.id && (
                <Checkbox
                    label="Change Password"
                    name="changePassword"
                    formik={formik}
                    variant="form"
                />
            )}

            {(!formik.values.id || formik.values.changePassword) && (
                <>
                    <Input
                        name="password"
                        type="password"
                        label="Password"
                        formik={formik}
                    />

                    <Input
                        name="confirmPassword"
                        type="password"
                        label="Confirm Password"
                        formik={formik}
                    />
                </>
            )}

            {!isOwnProfile && (
                <Checkbox
                    label="Admin"
                    onChange={(e) => {
                        formik.setFieldValue('role', e.target.checked ? "admin" : "user")
                    }}
                    variant="form"
                    formik={formik}
                    checked={formik.values.role === 'admin'}
                />
            )}
        </form>
    )
}

export default UserForm;